/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { UserCatalogDto } from './UserCatalogDto';
import {
    instanceOfUserCatalogDto,
    UserCatalogDtoFromJSON,
    UserCatalogDtoFromJSONTyped,
    UserCatalogDtoToJSON,
} from './UserCatalogDto';

/**
 * @type HistoryDtoUser
 * 
 * @export
 */
export type HistoryDtoUser = UserCatalogDto;


export function HistoryDtoUserFromJSON(json: any): HistoryDtoUser {
    return HistoryDtoUserFromJSONTyped(json, false);
}

export function HistoryDtoUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): HistoryDtoUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...UserCatalogDtoFromJSONTyped(json, true) };
    return  UserCatalogDtoFromJSONTyped(json, true);
}

export function HistoryDtoUserToJSON(value?: HistoryDtoUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfUserCatalogDto(value)) {
        return UserCatalogDtoToJSON(value as UserCatalogDto);
    }

    return {};
}

/**
 * Check if a given object implements the HistoryDtoUser interface.
 */
export function instanceOfHistoryDtoUser(value: any): value is HistoryDtoUser {
    if (instanceOfUserCatalogDto(value)) return true;
    return false;
}

